import { quickBooksAppOrigin } from './quickbooksEntry';

export const isQuickBooksAvailable = (tenant, domain) => {
  if (!tenant) return false;
  try {
    quickBooksAppOrigin(domain);
    return true;
  } catch (_error) {
    return false;
  }
};
